import { isEmpty } from "./validationUtil";
import { isValidEmail } from "./emailValidationUtil";

// @since NEXT_VERSION
// Mirrors EmployeeCodeValidator#PATTERN on the backend. The `i` flag lets the user type lowercase;
// the dialog upper-cases before submitting.
export const EMPLOYEE_CODE_PATTERN = /^[A-Z0-9][A-Z0-9._/-]{0,31}$/i;

// @since NEXT_VERSION
export const isValidEmployeeCode = (employeeCode) =>
  !isEmpty(employeeCode) && EMPLOYEE_CODE_PATTERN.test(String(employeeCode).trim());

/**
 *         const userObject = {
            description: activityDescription,
            clientTicketRef: activityClientTicketRef,
            ownerId: ownerId.ownerId,
            startDate: getDateInFormat(activityStartDate),
            endDate: getDateInFormat(activityEndDate),
            status: activityStatus,
            hoursSpent: parseInt(activityHoursSpent, 10),
        };
 * @param {*} userObject 
 */
// Returns true when a record points at a client that no longer exists. A
// record's client is considered missing when its id is empty/falsy, or when
// the loaded client list is non-empty and does not contain that id (the client
// was deleted). The non-empty guard avoids a false "deleted" verdict before the
// client list has finished loading.
export const isClientMissing = (clients, clientId) => {
    if (isEmpty(clientId)) return true;
    if (!Array.isArray(clients) || clients.length === 0) return false;
    return !clients.some((client) => parseInt(client.id, 10) === parseInt(clientId, 10));
};

export const validateUserObject = (userObject) => {

    // Must have certain fields
    // Username is no longer entered by users; the backend derives it from email.
    var isValid = userObject.hasOwnProperty("fullName") && !isEmpty(userObject.fullName);
    isValid = isValid && userObject.hasOwnProperty("email") && !isEmpty(userObject.email);
    isValid = isValid && isValidEmail(userObject.email);
    if(!userObject.id)
        isValid = isValid && userObject.hasOwnProperty("password") && !isEmpty(userObject.password);
    isValid = isValid && userObject.hasOwnProperty("status") && !isEmpty(userObject.status);
    isValid = isValid && userObject.hasOwnProperty("type") && !isEmpty(userObject.type);

    // @since NEXT_VERSION — Employee Code and Department.
    // CLIENT users are external: neither field applies, and neither is validated for them.
    // For employees the rule matches UserAdapter: required when creating, lenient when editing so a
    // legacy row with no code stays editable. A supplied value must always be well-formed.
    if (String(userObject.type).toUpperCase() === "EMPLOYEE") {
        const isCreate = !userObject.id;
        const hasCode = !isEmpty(userObject.employeeCode);

        if (isCreate) {
            isValid = isValid && hasCode && !isEmpty(userObject.departmentId);
        }
        if (hasCode) {
            isValid = isValid && isValidEmployeeCode(userObject.employeeCode);
        }
    }

    return isValid;
    // Field value validation
}
export const validateManagerObject = (managerObject) => {

    // Must have certain fields
    var isValid = managerObject.hasOwnProperty("clientEmail") && !isEmpty(managerObject.clientEmail);
    isValid = isValid && isValidEmail(managerObject.clientEmail);
    isValid = isValid && managerObject.hasOwnProperty("userId") && !isEmpty(managerObject.userId);
    isValid = isValid && managerObject.hasOwnProperty("clientId") && !isEmpty(managerObject.clientId);

    return isValid;
    // Field value validation
}

export const validateMemberObject = (memberObject) => {

    // Must have certain fields
    var isValid = memberObject.hasOwnProperty("clientEmail") && !isEmpty(memberObject.clientEmail);
    isValid = isValid && isValidEmail(memberObject.clientEmail);
    isValid = isValid && memberObject.hasOwnProperty("userId") && !isEmpty(memberObject.userId);
    isValid = isValid && memberObject.hasOwnProperty("clientId") && !isEmpty(memberObject.clientId);

    return isValid;
    // Field value validation
}

// `clientId` is required on the form state to gate the UI, even though the
// API payload only carries memberId and managerId (the backend derives the
// client from the member). Keep clientId in this check so the dialog can't
// submit until a client is picked.
export const validateMemberReportingObject = (memberObject) => {

    // Must have certain fields
    var isValid = memberObject.hasOwnProperty("clientId") && !isEmpty(memberObject.clientId);
    isValid = isValid && memberObject.hasOwnProperty("memberId") && !isEmpty(memberObject.memberId);
    isValid = isValid && memberObject.hasOwnProperty("managerId") && !isEmpty(memberObject.managerId);

    return isValid;
    // Field value validation
}